import script from "./radio-widget-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./radio-widget-ly.vue?vue&type=script&setup=true&lang=js"

import "./radio-widget-ly.vue?vue&type=style&index=0&id=0bdaeb59&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bdaeb59"]])

export default __exports__